import { render } from "./InputFileCustom.vue?vue&type=template&id=2e96c432"
import script from "./InputFileCustom.vue?vue&type=script&lang=js"
export * from "./InputFileCustom.vue?vue&type=script&lang=js"

import "./InputFileCustom.vue?vue&type=style&index=0&id=2e96c432&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__